import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import { toast } from "react-toastify";
import OfferImage from "../OfferImage/OfferImage";
import SoftCard, { PriceRow } from "../SoftCard/SoftCard";
import { getToken } from "../../Utils/authHelper";
import { postData } from "../../Webservice/Webservice";
import { useCart } from "../../context/CartContext";

// Combo pack card: the same soft, rounded look as the product cards on the home page.
const ComboCard = ({ combo, isBusiness = false, width, scrollTop = false, showPercent = true }) => {
  const navigate = useNavigate();
  const { fetchCartCount } = useCart();
  const [adding, setAdding] = useState(false);
  const items = combo.products?.length || 0;
  const price = isBusiness ? (combo.b2b_sellingPrice || combo.b2c_sellingPrice) : combo.b2c_sellingPrice;
  const mrp = isBusiness ? (combo.b2b_mrp || combo.b2c_mrp) : combo.b2c_mrp;
  const off = mrp && price && mrp > price ? Math.round(((mrp - price) / mrp) * 100) : 0;
  // same amount the combo page shows as "You save"
  const saved = mrp && price && mrp > price ? +(mrp - price).toFixed(2) : 0;
  // the server works stock out live from the products (seller products never run out)
  const inStock = combo.inStock !== false && combo.isActive !== false;

  const open = () => { navigate(`/combo-details/${combo._id}`, { state: { combo } }); if (scrollTop) window.scrollTo(0, 0); };

  const quickAdd = async () => {
    const token = getToken();
    if (!token) { navigate("/signin"); return; }
    setAdding(true);
    try {
      const res = await postData("cart/add-to-cart", { product_id: combo._id, quantity: 1, isCombo: true }, `Bearer ${token}`, false, false);
      if (res && (res.success || res.cart)) {
        toast.success("Combo added to cart");
        fetchCartCount();
      } else {
        toast.error(res?.message || "Could not add to cart");
      }
    } catch (err) {
      toast.error(err.message || "Could not add to cart");
    } finally {
      setAdding(false);
    }
  };

  return (
    <SoftCard
      width={width}
      onClick={open}
      outOfStock={!inStock}
      badge={saved > 0 ? `Save ₹${saved}` : showPercent && off > 0 ? `${off}% OFF` : null}
      image={<OfferImage images={combo.product_images} alt={combo.title} fit="cover" fill dotsTop imgClassName="soft-img" fallback={<div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 48 }}>🎁</div>} />}
      action={{ icon: <ShoppingCartOutlinedIcon sx={{ fontSize: 19 }} />, label: "Add to cart", onClick: quickAdd, loading: adding }}
      kicker={`Combo pack · ${items} items`}
      title={combo.title}
    >
      <PriceRow price={price ? `₹${Number(price).toFixed(0)}` : ""} mrp={mrp && price && mrp > price ? `₹${Number(mrp).toFixed(0)}` : null} note={showPercent && off > 0 ? `${off}% off` : null} />
    </SoftCard>
  );
};

export default ComboCard;
